import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
} from "@mui/material";
import axios from "axios";
import { Close } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { toast } from "react-toastify";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import moment from "moment";
const SupplierTermSheet = () => {
  const [supplierermsheet, setSupplierermsheet] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [open, setOpen] = useState(false);
  const [opendel, setOpenDel] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState(false);
  const [file, setFile] = useState("");
  useEffect(() => {
    getAllSupplierermsheet(0, "");
  }, []);

  const getAllSupplierermsheet = (page, search) => {
    const data = {
      page: page,
      limit: 10,
      searchChar: search,
    };
    axios
      .post(process.env.REACT_APP_BACKEND + "get-suppliertermsheet", data, {
        headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
      })
      .then((resp) => {
        setSupplierermsheet(resp && resp.data && resp.data.data);
        setCount(resp && resp.data && resp.data.totalcount);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      name: "gmpStatusRequired",
      label: "GMP status ",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "dosageFormsOfInterest",
      label: "Dosage forms",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "indicativeVolumes",
      label: "Indicative Volumes",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "specialCapabilitiesRequired",
      label: "Special capabilities",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>{supplierermsheet[dataIndex]?.status ? "Agreed" : "Disagreed"}</>
          );
        },
      },
    },
    {
      name: "Dossier",
      label: "Supplier Id",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{supplierermsheet[dataIndex]?.supplierId?.Supplier_ID}</>;
        },
      },
    },
    {
      name: "userId",
      label: "User",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{supplierermsheet[dataIndex]?.userId?.name}</>;
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{supplierermsheet[dataIndex]?.userId?.Email}</>;
        },
      },
    },
    {
      name: "createdAt",
      label: "Submitted Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(supplierermsheet[dataIndex]?.createdAt).format(
                "DD-MM-YYYY"
              )}
            </div>
          );
        },
      },
    },
    {
      name: "indicativeVolumes",
      label: "CDA/ NDA",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const fileUrl = supplierermsheet[dataIndex]?.cdaOrNda;

          return (
            <>
              <Tooltip
                title={fileUrl ? "Download CDA/NDA" : "No file available"}
              >
                <span>
                  <IconButton
                    aria-label="download supplier TermSheet"
                    onClick={() => handleDownload(fileUrl)}
                    disabled={!fileUrl}
                  >
                    <GetAppOutlinedIcon className="fs-20" />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          );
        },
      },
    },
    {
      name: "indicativeVolumes",
      label: "RFQ",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const fileUrl = supplierermsheet[dataIndex]?.rfq;
          return (
            <>
              <Tooltip title={fileUrl ? "Download RFQ" : "No file available"}>
                <span>
                  <IconButton
                    aria-label="download RFQ"
                    onClick={() => handleDownload(fileUrl)}
                    disabled={!fileUrl}
                  >
                    <GetAppOutlinedIcon className="fs-20" />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          );
        },
      },
    },
    {
      name: "Action",
      label: "Action",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Delete SupplierTermSheet">
                <IconButton
                  aria-label="delete SupplierTermSheet"
                  onClick={() =>
                    handleOpen(supplierermsheet[dataIndex]?._id, "delete")
                  }
                >
                  <DeleteOutlineOutlinedIcon className="fs-20 delete-icon" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  const handleDownload = async (fileUrl) => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          // Add any headers here if needed
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      //const fileName = fileUrl.split("/").pop();// Previously this was generating random NUmbers with Filename
      const rawFileName = fileUrl.split("/").pop();
      const fileName = rawFileName?.includes("-")
        ? rawFileName.substring(rawFileName.indexOf("-") + 1)
        : rawFileName;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "download.pdf"; // fallback filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); // clean up
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  //option for mui datatable
  const options = {
    responsive: "standard",
    download: false,
    selectableRows: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    count: count,
    rowsPerPageOptions: [], // hide the "Rows per page" dropdown by providing an empty array
    rowsPerPage: 10,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        console.log(tableState.page, "Count");
        getAllSupplierermsheet(tableState.page, "");
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      getAllSupplierermsheet(page, searchText);
    },
  };
  //Function to make dailog box open and set the state

  const handleOpen = (supplierermsheet, type, status) => {
    if (type === "delete") {
      setId(supplierermsheet);
      setOpenDel(true);
    } else if (type === "edit") {
      setId(supplierermsheet);
      setOpen(true);
      setType("edit");
      setStatus(status);
    } else if (type === "upload") {
      setOpenUpload(true);
      setType("upload");
    }
  };

  //Function to make close the dailog box close
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setFile("");
    setStatus(false);
    setOpenUpload(false);
  };

  //
  const handleSubmit = () => {
    if (type === "edit") {
      const data = {
        id: id,
        status: !status,
      };
      axios
        .post(process.env.REACT_APP_BACKEND + "update-supplierermsheet", data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplierermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    } else if (type === "upload") {
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          process.env.REACT_APP_BACKEND + "create-supplierermsheet",
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage?.getItem("token")}`,
            },
          }
        )
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplierermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    } else {
      const data = {
        id: id,
      };

      axios
        .post(
          process.env.REACT_APP_BACKEND + "delete-suppliertermsheet",
          data,
          {
            headers: {
              Authorization: `Bearer ${localStorage?.getItem("token")}`,
            },
          }
        )
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplierermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    }
  };
  const handleFileChange = (event) => {
    const files = event.target.files[0];
    setFile(files);
  };
  return (
    <div className="p-4">
      <div
        className="mb-5"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="primary_title text-start about_heading m-2 mb-3">
          Supplier Termsheet
        </h2>
        {/* <Button
          variant="contained"
          className="btn ms-4"
          onClick={() => handleOpen("", "upload")}
        >
          Upload CSV
        </Button> */}
      </div>

      <MUIDataTable
        // title={"SupplierTermSheet Management"}
        data={supplierermsheet}
        columns={columns}
        options={options}
      />

      {/* Dialog box foe create and edit opetator */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Edit SupplierTermSheet Status</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            {status
              ? "Are sure want to Inactive SupplierTermSheet.?"
              : "Are sure want to Active SupplierTermSheet.?"}
          </p>
          <div className="text-center mt-4">
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className="small-button ms-4"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* Dialog box to delete the operator */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Delete SupplierTermSheet</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            Are you sure you want to delete the SupplierTermSheet ?
          </p>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleSubmit}
          >
            Delete
          </Button>
        </div>
      </Dialog>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={openUpload}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Upload SupplierTermSheet</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <div className="m-auto text-center">
            <input
              type="file"
              id="cda"
              onChange={handleFileChange}
              multiple // Allows multiple file selection if needed
            />
          </div>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default SupplierTermSheet;
